
import { useI18n } from 'vue-i18n';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';
import {
  defineComponent,
  onMounted, PropType, ref, SetupContext, watch,
} from 'vue';
import DeclencheurCustomJSMetaData, {
  DeclencheurCustomJSData,
} from '@/components/automated-scenarios/metadata/declencheurs/DeclencheurCustomJSMetadata';

export default defineComponent({
  name: 'DeclencheurCustomJS',
  components: {
    Textarea,
    Button,
  },

  props: {
    modelValue: {
      type: Object as PropType<DeclencheurCustomJSData>,
      required: true,
      default() {
        return DeclencheurCustomJSMetaData.Create();
      },
    },
  },

  emits: ['update:modelValue'],

  setup(props: { modelValue: DeclencheurCustomJSData }, context: SetupContext) {
    const { t } = useI18n();

    const script = ref('');

    // eslint-disable-next-line vue/no-setup-props-destructure
    script.value = props.modelValue.token_script;

    const copy = () => {
      navigator.clipboard.writeText(script.value).then(() => null, () => null);
    };

    const update = () => context.emit(
      'update:modelValue',
      DeclencheurCustomJSMetaData.Create({
        token_script: script.value,
      }),
    );

    watch([script], update);
    onMounted(update);

    return {
      t,
      script,
      copy,
    };
  },
});
